import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import config from '../../baseConfig';
import { trans, setComoAfter3Symbol } from '../../helpers';
import ErrorModal from '../Fragments/ErrorModal';
import B2bLanguageList from './blocks/B2bLanguageList';
import B2bUserInfo from './blocks/B2bUserInfo';
import { localStorageGetItem } from '../../storage';
import SimpleCrypto from 'simple-crypto-js';
import Tab from '../Fragments/Tab';
import Loading from '../Fragments/Loading';
import ApiManager from '../../apiManager';
import B2bBanInfo from './blocks/B2bBanInfo';
import B2bCtnView from './blocks/B2bCtnView';
import B2bCuratorList from './blocks/B2bCuratorList';
import EmptyBox from './blocks/EmptyBox';
import B2bMyAccount from './blocks/B2bMyAccount';
import B2bCreateCurator from './blocks/B2bCreateCurator';
import B2bCreateApplication from './blocks/B2bCreateApplication';
import B2bApplications from './blocks/B2bApplications';
import B2bEditApplication from './blocks/B2bEditApplication';
import B2bFinancialReports from './blocks/B2bFinancialReports';

class B2bProfileView extends Component {

    constructor( props ){
        super( props );

        this.curator = Number( this.props.cookies.get('loginByCurator') ) === 1 ? 'curator' : '';

        this.state = {
            // Globals
            loginToken: this.props.cookies.get('loginTokenB2b'),
            urlPrefix: 'b2b',
            showErrorModal: false,
            leftMenuToggle: false,
            activeTab: this.curator === 'curator' ? 'ban' : 'inn',
            buttonDisabled: false,
            logoutBtnDisabled: false,
            pathname: this.filteredArray( this.props.location.pathname ),
            profileData: '',
            applicationData: [],
            notificationCount: 0,
            banSelectedTp: '',
            isLanguageChanged: false,
            // INN
            innActiveCtn: '',
            innActiveBan: '',
            innItems: '',
            innSelectedItem: '',
            innMaxLength: 8,
            innScrollShowItemsDef: 20,
            innScrollShowItems: 20,
            innScrollLimit: 10,
            innVal: '',
            innActiveTabIndex: 0,
            innActiveCtnView: false,
            innBoxCtnItems: '',
            // BAN
            banSelectedItem: '',
            banVal: '',
            banActiveTabIndex: 0,
            banActiveCtnView: false,
            banBoxCtnItems: '',
            banScrollShowItemsDef: 20,
            banScrollShowItems: 20,
            banScrollLimit: 10,
            banItems: '',
            banActiveBan: '',
            banFilter: false,
            // CTN
            ctnVal: '',
            ctnActiveCtnView: false,
            ctnBoxCtnItems: '',
            ctnActiveTabIndex: 0,
            ctnSelectedItem: ''
        };

        // Component props
        this.timeout = null;
        this.notificationCountTimer = null;
        this.componentIsMounted = true;
        this.innActiveBan = '';

        // Bind own methods
        this.languageChange = this.languageChange.bind( this );
        this.updateParentState = this.updateParentState.bind( this );
        this.getDecryptedToken = this.getDecryptedToken.bind( this );
        this.getInnData = this.getInnData.bind( this );
        this.getInnDataSuccess = this.getInnDataSuccess.bind( this );
        this.getInfoByBanSuccess = this.getInfoByBanSuccess.bind( this );
        this.getInfoByCtnSuccess = this.getInfoByCtnSuccess.bind( this );
        this.getInfoByBanForViewSuccess = this.getInfoByBanForViewSuccess.bind( this );
        this.logout = this.logout.bind( this );
        this.getInfoByCtn = this.getInfoByCtn.bind( this );
        this.resetValues = this.resetValues.bind( this );
        this.updatePath = this.updatePath.bind( this );
        this.getProfileSuccess = this.getProfileSuccess.bind(this);
        this.getInnCuratorDataSuccess = this.getInnCuratorDataSuccess.bind(this);
        this.getProfile = this.getProfile.bind(this);
        this.getNotificationSuccess = this.getNotificationSuccess.bind(this);
        this.errorCallBack = this.errorCallBack.bind( this );

    }

    updateParentState( newState ){
        this.setState( newState );
    }

    updatePath(){

        this.setState({
            pathname: this.filteredArray( this.props.history.location.pathname )
        });

    }

    filteredArray( str ){
        return str.replace(/^\/myaccount/, '').split('/').filter(( index ) => index !== '');
    }

    balanceView(){

        const selectedItem = this.state[this.state.activeTab + 'SelectedItem'];

        if ( selectedItem !== '' && selectedItem !== 'loading' && selectedItem.status === 'OK' && selectedItem.data.ban_info.plan === 'postpaid' ) {
            return (
                <span className="list__link-inner db pr">
                    <span className="list__link-inner-item ver-top-box">
                        <span className="list__link-inner-title db fs12">{trans( this.props.b2bTrans, 'b2b.ban.balance_title' )}</span>
                        <span className="list__link-inner-number db fb fs12">{setComoAfter3Symbol( selectedItem.data.ban_info.ban_balance )} ֏</span>
                    </span>
                    <span className="list__link-inner-item ver-top-box">
                        <span className="list__link-inner-title db fs12">{trans( this.props.b2bTrans, 'b2b.ban.balance_limit_title' )}</span>
                        <span className="list__link-inner-number db fb fs12">{setComoAfter3Symbol( selectedItem.data.ban_info.available_limit )} ֏</span>
                    </span>
                </span>
            );
        }

        return '';

    }

    resetValues(){

        this.setState({
            // INN
            innActiveCtn: '',
            innActiveBan: '',
            innItems: '',
            innSelectedItem: '',
            innMaxLength: 8,
            innScrollShowItemsDef: 20,
            innScrollShowItems: 20,
            innScrollLimit: 10,
            innVal: '',
            innActiveTabIndex: 0,
            innActiveCtnView: false,
            innBoxCtnItems: '',
            // BAN
            banSelectedItem: '',
            banVal: '',
            banActiveTabIndex: 0,
            banActiveCtnView: false,
            banBoxCtnItems: '',
            banActiveCtn: '',
            banActiveBan: '',
            banScrollShowItemsDef: 20,
            banScrollShowItems: 20,
            banScrollLimit: 10,
            // CTN
            ctnVal: '',
            ctnActiveCtnView: false,
            ctnBoxCtnItems: '',
            ctnSelectedItem: '',
            // Globals
            pathname: this.filteredArray( this.props.location.pathname ),
            activeTab: this.curator === 'curator' ? 'ban' : 'inn'
        }, this.updatePath);

    }

    initPathActions( pushState ){

        if ( this.state.activeTab === 'inn' ) {

            if ( pushState ) {
                this.doSearch();

                if ( this.innActiveBan !== '' ) {
                    this.getInfoByBanForView( this.state['innVal'], this.innActiveBan );
                }

            } else {

                if ( this.state.innItems === '' ) {
                    this.doSearch();
                }

                if ( this.state.innActiveBan !== '' && this.curator !== 'curator' ) {
                    this.getInfoByBanForView( this.state['innVal'], this.state.innActiveBan );
                }

            }

        } else if ( this.state.activeTab === 'ban' ) {

            if ( this.state.banSelectedItem === '' ) {
                this.doSearch();
            }

        }

        if ( this.state[this.state.activeTab + 'ActiveCtnView'] && this.curator !== 'curator' ) {
            this.getInfoByCtn( this.state.ctnPathValue, true );
        }

    }

    pathSetter( pushState ){

        const pathName = this.filteredArray( this.props.location.pathname );
        const defaultState = {
            pathname: pathName,
            innVal: '',
            innActiveCtnView: false,
            innActiveBan: '',
            innActiveTabIndex: 0,
            banVal: '',
            banActiveCtnView: false,
            banActiveTabIndex: 0,
            banActiveBan: '',
            ctnVal: '',
            ctnActiveCtnView: false
        };
        pushState = typeof pushState === 'undefined';

        // INN case
        if ( pathName[1] === 'inn' ) {
            defaultState['activeTab'] = 'inn';

            if ( pathName[2] && pathName[2].length === 8 && !isNaN( pathName[2] ) ) {

                defaultState['innVal'] = pathName[2];
                defaultState['innActiveCtnView'] = false;

                if ( pathName[3] === 'ban' && !isNaN( pathName[4] ) ) {
                    if ( pushState ) {
                        this.innActiveBan = Number( pathName[4] );
                    } else {
                        this.innActiveBan = '';
                        defaultState['innActiveBan'] = Number( pathName[4] );
                    }

                    defaultState['activeTab'] = pathName[1];
                }

                if ( pathName[5] === 'ctn' && !isNaN( pathName[6] ) ) {
                    defaultState[defaultState['activeTab'] + 'ActiveCtnView'] = true;
                    defaultState['ctnPathValue'] = pathName[6];
                    defaultState['innActiveCtn'] = pathName[6];
                    defaultState[defaultState['activeTab'] + 'ActiveTabIndex'] = 1;
                }

            }

            // BAN case
        } else if ( pathName[1] === 'ban' ) {
            defaultState['activeTab'] = 'ban';

            if ( pathName[2] && !isNaN( pathName[2] ) ) {

                defaultState['banVal'] = pathName[2];
                defaultState['banActiveCtnView'] = false;

                if ( this.curator === 'curator' ) {
                    defaultState['banActiveBan'] = Number( pathName[2] );
                }

                if ( pathName[3] === 'ctn' && !isNaN( pathName[4] ) ) {
                    defaultState['banActiveCtnView'] = true;
                    defaultState['banActiveTabIndex'] = 1;
                    defaultState['ctnPathValue'] = pathName[4];
                    defaultState['banActiveCtn'] = pathName[4];
                }

            }

        } else if ( pathName[1] === 'ctn' ) {
            defaultState['activeTab'] = 'ctn';

            if ( pathName[2] && !isNaN( pathName[2] ) ) {

                defaultState['ctnVal'] = pathName[2];
                defaultState['ctnActiveCtnView'] = true;
                defaultState['ctnPathValue'] = pathName[2];

            }

        } else {
            this.resetValues();
        }

        this.setState(defaultState, () => this.initPathActions( pushState ));

    }

    componentDidMount() {

        this.pathSetter();

         this.props.history.listen((location, action) => {

             if ( this.componentIsMounted && action !== 'PUSH' ) {
                 this.pathSetter( 'pushState' );
             }

         });

         // Init requests
         this.initAsyncCalls();

        // Close session
        // window.addEventListener('beforeunload', () => {
        //     this.props.cookies.remove('loginTokenB2b', { path: config.urlPrefix });
        // });

    }

    componentWillUnmount() {

        this.clearLogoutTimer();
        this.componentIsMounted = false;
        if ( this.notificationCountTimer !== null ) {
            clearInterval( this.notificationCountTimer );
        }

    }

    getProfile(){

        this.setState({
            profileData: ''
        });

        ApiManager.getRequest({
            jwt: this.getDecryptedToken()
        }, '/b2b' + this.curator + '/profile').then( this.getProfileSuccess, this.errorCallBack );

    }

    getNotificationCount(){

        ApiManager.getRequest({
            jwt: this.getDecryptedToken()
        }, '/b2b' + this.curator + '/application/count').then( this.getNotificationSuccess, this.errorCallBack );

    }

    getNotificationSuccess({ data }){

        if ( data.status === 'OK' ) {
            if ( data.data.count !== this.state.notificationCount ) {
                this.setState({
                    notificationCount: data.data.count
                });
            }
        }

    }

    initAsyncCalls() {

        // Get profile info
        this.getProfile();

        // Get notification count
        this.getNotificationCount();
        this.notificationCountTimer = setInterval(() => this.getNotificationCount(), 5000);

    }

    getInnCuratorDataSuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return;
        }

        if ( resolve.data.status === 'OK' ) {

            resolve.data.data.info.bans = this.state.profileData.data.bans.reduce(( arr, item ) => {

                for( let i of resolve.data.data.info.bans ){
                    if ( item.ban === i.ban ) {
                        arr.push( i );
                    }
                }

                return arr;

            }, []);
            resolve.data.data.count = resolve.data.data.info.bans.length;

            this.setState({
                banItems: resolve.data,
                buttonDisabled: false
            });

            if ( this.state.banActiveBan !== '' ) {
                this.getInfoByBan();
            }

            if ( this.state.ctnPathValue ) {
                this.getInfoByCtn( this.state.ctnPathValue, true );
            }

        } else {
            this.errorCallBack();
        }

    }

    getProfileSuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return;
        }

        if ( resolve.data.status === 'OK' ) {

            this.setState({
                profileData: resolve.data
            });

            if ( this.curator === 'curator' ) {

                this.setState({
                    buttonDisabled: true
                });

                // Get ban list
                ApiManager.getRequest({
                    jwt: this.getDecryptedToken(),
                    inn: resolve.data.data.inn
                }, '/b2bcurator/getInfoByInn').then( this.getInnCuratorDataSuccess, this.errorCallBack );

            }

        } else {
            this.errorCallBack();
        }

    }

    logoutTimer(){

        this.clearLogoutTimer();

        this.timeout = setTimeout(() => {

            if ( this.state.loginToken ) {
                this.logout();
            }

        }, config.logoutTimer);

    }

    clearLogoutTimer(){

        if ( this.timeout ) {
            clearTimeout( this.timeout );
        }

    }

    errorCallBack( reject ){
        this.setState({ showErrorModal: true });
    }

    getInnData( inINN ){

        this.setState({
            innSelectedItem: '',
            innActiveBan: '',
            innItems: '',
            innScrollShowItems: this.state.innScrollShowItemsDef,
            buttonDisabled: true
        });

        // Get INN
        ApiManager.getRequest({
            jwt: this.getDecryptedToken(),
            inn: this.state.innVal || ( inINN && inINN )
        }, '/b2b/getInfoByInn').then( this.getInnDataSuccess, this.errorCallBack );

    }

    getInnDataSuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return;
        }

        // @test
        // resolve.data = { "status": "OK", "error": null, "data": { "inn": "00025841", "count": 155, "info": { "bans": [ { "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ", "account_type": 45, "address": "Երեվան ԲՈՒԴԱՂՅԱՆ 1", "ban_status": "O", "ban": 112743857, "contact_number": 7410234900 }, { "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ ԻՐԱՆԻ ԻՍԼԱՄԱԿԱՆ ՀԱՆՐԱՊԵՏՈ", "account_type": 45, "address": "Երեվան ԲՈՒԴԱՂՅԱՆ 1,ՄԱՇՏՈՑ", "ban_status": "O", "ban": 112761424, "contact_number": 7410653885 }, { "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ ԻՐԱՆԻ ԻՍԼԱՄԱԿԱՆ ՀԱՆՐ.ԴԵՍՊ", "account_type": 45, "address": "Երեվան ԱՅԳԵՍՏԱՆ 9Փ 2Ա", "ban_status": "O", "ban": 112777376, "contact_number": 7410559977 }, { "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ Իրանի Իսլամ. Հանր.դես.", "account_type": 43, "address": "Երևան Լվովյան 8", "ban_status": "O", "ban": 112812352, "contact_number": 7410633718 }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 35, "address": "Բուդաղյան 1", "ban_status": "O", "ban": 113297949, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 35, "address": "Բուդաղյան 1", "ban_status": "O", "ban": 113300489, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 35, "address": "Երևան Բուդաղյան 1", "ban_status": "O", "ban": 113301947, "contact_number": 7491777882 }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 35, "address": "Բուդաղյան 1", "ban_status": "O", "ban": 113301118, "contact_number": null }, { "business_name": "ԻՐԱՆԻ ԻՍԼԱՄԱԿԱՆ ՀԱՆՐԱՊԵՏՈ", "account_type": 43, "address": "Երեվան ԲՈՒԴԱՂՅԱՆ 1", "ban_status": "O", "ban": 116336093, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 5, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 118562574, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493362, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493368, "contact_number": null }, { "business_name": "Համատիրություն Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493380, "contact_number": 7491777882 }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493392, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493395, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493398, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493407, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493410, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493421, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493983, "contact_number": 7491777882 }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493987, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493989, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493991, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493645, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493647, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493650, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493652, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493655, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493662, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493669, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493676, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493683, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493685, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119494155, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119494157, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119494161, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119494163, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119494170, "contact_number": null }, { "business_name": "ԻՐԱՆԻ ԻՍԼԱՄԱԿԱՆ ՀԱՆՐԱՊԵՏՈ", "account_type": 43, "address": "Երեվան ԲՈՒԴԱՂՅԱՆ 1", "ban_status": "O", "ban": 118895686, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119383451, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1 Գրասենյա", "ban_status": "O", "ban": 119710047, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն ԻՐանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1 Գրասենյա", "ban_status": "O", "ban": 119669401, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090946, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090947, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090948, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090949, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090951, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090952, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090953, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090954, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090955, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090957, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090958, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090959, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ. Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090960, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090961, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090962, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090963, "contact_number": null }, { "business_name": "Իրանի Իսլամական հանրապետութ. դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120224752, "contact_number": null }, { "business_name": "ՀՀ իրավաբանական անձի մասնաճյուղ Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120466366, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120465899, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855925, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855927, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855929, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855931, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855933, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855915, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855917, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855919, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855921, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855923, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120968247, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120968252, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120968034, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական անրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120968035, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120968036, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121008502, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121008504, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121008568, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121008569, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121008570, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997975, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997977, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997979, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997981, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997983, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997985, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997987, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997989, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034597, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121038339, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121038340, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121038341, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121038342, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121038343, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034598, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034599, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034600, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034601, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034602, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034603, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034604, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034605, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034606, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034607, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034608, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034609, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034610, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034611, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034612, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034613, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034658, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034659, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034660, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034661, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034662, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034663, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034664, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական  Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034665, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034666, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034667, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034668, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034669, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034670, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034671, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034672, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034673, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034705, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երևան Բուդաղյան 1", "ban_status": "O", "ban": 121034706, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034707, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034708, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034710, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034711, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034712, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034713, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034714, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121043046, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034894, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034895, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034896, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034897, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034898, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034899, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034900, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081103, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081119, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081129, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121080868, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121080880, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081139, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081145, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081159, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081165, "contact_number": 7491777882 }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121080916, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081783, "contact_number": null } ] } } };

        this.setState({
            innItems: resolve.data,
            buttonDisabled: false
        });

    }

    getInfoByBan(){

        this.setState({
            banSelectedItem: 'loading',
            buttonDisabled: true,
            banActiveCtnView: false
        });

        const params = {
            jwt: this.getDecryptedToken(),
            ban: this.state.banVal
        };

        if ( this.curator === 'curator' && this.state.profileData !== '' && this.state.profileData.status === 'OK' ) {
            params['inn'] = this.state.profileData.data.inn;
        }

        // Get BAN info
        ApiManager.getRequest(params, '/b2b' + this.curator + '/getInfoByBan').then( this.getInfoByBanSuccess, this.errorCallBack );

    }

    getInfoByBanSuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return;
        }

        // @test
        // resolve.data = { "status": "OK", "error": null, "data": { "ctn_info": [ { "count": 20, "info": { "ctns": [ { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230006, "ctn_status": "S" }, { "pp": "BASE1B", "last_status_date": "06.08.2011 00:00:00", "activation_date": "06.08.2011 00:00:00", "activity_description": "Activation", "ctn": 7410234981, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410234980, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "09.09.2011 00:00:00", "activation_date": "09.09.2011 00:00:00", "activity_description": "Activation", "ctn": 7410234982, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410234983, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230052, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230072, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "12.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230079, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230082, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "09.09.2011 00:00:00", "activation_date": "09.09.2011 00:00:00", "activity_description": "Activation", "ctn": 7410232920, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410232553, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410232952, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410233777, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410234900, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410235833, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.08.2016 00:00:00", "activation_date": "24.08.2016 00:00:00", "activity_description": "Activation", "ctn": 7410572851, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410280457, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.07.2015 00:00:00", "activation_date": "24.07.2015 00:00:00", "activity_description": "Change CTN", "ctn": 7410531447, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.08.2016 00:00:00", "activation_date": "24.08.2016 00:00:00", "activity_description": "Activation", "ctn": 7410572815, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "07.10.2014 00:00:00", "activation_date": "07.10.2014 00:00:00", "activity_description": "Activation", "ctn": 7410544738, "ctn_status": "A" } ] } } ], "ban_info": { "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ ԻՐԱՆԻ", "account_type": 45, "address": "Երեվան ԲՈՒԴԱՂՅԱՆ 1", "available_limit": 358987.37, "ban_status": "O", "ban_balance": 33088.989999999998, "plan": "postpaid", "ban": 113543841, "contact_number": 7410234900 } } };
        // resolve.data = { "status": "OK", "error": null, "data": { "ctn_info": [ { "count": 1, "info": { "ctns": { "pp": "LEADER_S", "last_status_date": "01.02.2008 00:00:00", "activation_date": "01.02.2008 00:00:00", "activity_description": "Activation", "ctn": 7491432767, "ctn_status": "A" } } } ], "ban_info": { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 35, "address": "Բուդաղյան 1", "available_limit": 1244013.21, "ban_status": "O", "ban_balance": 38738.21, "plan": "postpaid", "ban": 113297949, "contact_number": null } } };

        this.setState({
            banSelectedItem: resolve.data,
            buttonDisabled: false
        });

    }

    getInfoByCtn( msisdn, buttonDisabled = false ){

        const newState = { buttonDisabled };

        newState[this.state.activeTab + 'BoxCtnItems'] = '';

        this.setState( newState );

        const params = {
            jwt: this.getDecryptedToken(),
            msisdn
        };

        if ( this.curator === 'curator' ) {
            params['inn'] = this.state.profileData.data.inn;

            if ( this.state.activeTab === 'ban' && this.state.banVal !== '' ) {
                params['ban'] = this.state.banVal;
            }

        }

        // Get CTN info
        ApiManager.getRequest(params, '/b2b' + this.curator + '/getInfoByCtn').then( this.getInfoByCtnSuccess, this.errorCallBack );

    }

    getInfoByCtnSuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return;
        }

        // @test
        // resolve.data = { "status": "OK", "error": null, "data": { "subscriber": 37410234981, "info": { "pp": "BASE1B", "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ ԻՐԱՆԻ ԻՍԼԱՄԱԿԱՆ ՀԱՆՐԱՊԵՏՈ", "account_type": 45, "available_limit": 358987.37, "sub_status": "A", "ban_balance": 33088.989999999998, "unbilled_balance": 0, "plan": "postpaid", "ban": "112743857" } } };

        const newState = {
            buttonDisabled: false
        };

        newState[this.state.activeTab + 'ActiveCtnView'] = true;
        newState[this.state.activeTab + 'BoxCtnItems'] = resolve.data;

        this.setState( newState );

    }

    getInfoByBanForView( inn = '', ban ){

        const data = {
            innSelectedItem: 'loading',
            banActiveCtnView: false
        };

        if ( this.curator === 'curator' ) {
            data['banSelectedItem'] = 'loading';
        }

        this.setState( data );

        const params = {
            jwt: this.getDecryptedToken(),
            ban
        };

        if ( inn !== '' ) {
            params['inn'] = inn;
        }

        // Get BAN info
        ApiManager.getRequest(params, '/b2b' + this.curator + '/getInfoByBan').then( this.getInfoByBanForViewSuccess, this.errorCallBack );

    }

    getInfoByBanForViewSuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return;
        }

        // @test
        // resolve.data = { "status": "OK", "error": null, "data": { "ctn_info": [ { "count": 25, "info": { "ctns": [ { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230006, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230052, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230072, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "12.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230079, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230082, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410232553, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "09.09.2011 00:00:00", "activation_date": "09.09.2011 00:00:00", "activity_description": "Activation", "ctn": 7410232920, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410232952, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410233777, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410234900, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410234980, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "06.08.2011 00:00:00", "activation_date": "06.08.2011 00:00:00", "activity_description": "Activation", "ctn": 7410234981, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "09.09.2011 00:00:00", "activation_date": "09.09.2011 00:00:00", "activity_description": "Activation", "ctn": 7410234982, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410234983, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410235833, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410280457, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "07.10.2014 00:00:00", "activation_date": "07.10.2014 00:00:00", "activity_description": "Activation", "ctn": 7410544738, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.07.2015 00:00:00", "activation_date": "24.07.2015 00:00:00", "activity_description": "Change CTN", "ctn": 7410531447, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.08.2016 00:00:00", "activation_date": "24.08.2016 00:00:00", "activity_description": "Activation", "ctn": 7410572815, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.08.2016 00:00:00", "activation_date": "24.08.2016 00:00:00", "activity_description": "Activation", "ctn": 7410572851, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.08.2016 00:00:00", "activation_date": "24.08.2016 00:00:00", "activity_description": "Activation", "ctn": 7410572851, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.08.2016 00:00:00", "activation_date": "24.08.2016 00:00:00", "activity_description": "Activation", "ctn": 7410572851, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.08.2016 00:00:00", "activation_date": "24.08.2016 00:00:00", "activity_description": "Activation", "ctn": 7410572851, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.08.2016 00:00:00", "activation_date": "24.08.2016 00:00:00", "activity_description": "Activation", "ctn": 7410572851, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.08.2016 00:00:00", "activation_date": "24.08.2016 00:00:00", "activity_description": "Activation", "ctn": 7410572859, "ctn_status": "A" } ] } } ], "ban_info": { "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ", "account_type": 45, "address": "Երեվան ԲՈՒԴԱՂՅԱՆ 1", "available_limit": 357640.5, "ban_status": "O", "ban_balance": 33088.989999999998, "plan": "postpaid", "ban": 112743857, "contact_number": 7410234900 } } };
        // resolve.data = { "status": "OK", "error": null, "data": { "ctn_info": [ { "count": 20, "info": { "ctns": [ { "pp": "BASE1B", "last_status_date": "07.10.2014 00:00:00", "activation_date": "07.10.2014 00:00:00", "activity_description": "Activation", "ctn": 7410544738, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230006, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230052, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230072, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "12.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230079, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410230082, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410232553, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "09.09.2011 00:00:00", "activation_date": "09.09.2011 00:00:00", "activity_description": "Activation", "ctn": 7410232920, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410232952, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410233777, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410234900, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410234980, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "06.08.2011 00:00:00", "activation_date": "06.08.2011 00:00:00", "activity_description": "Activation", "ctn": 7410234981, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "09.09.2011 00:00:00", "activation_date": "09.09.2011 00:00:00", "activity_description": "Activation", "ctn": 7410234982, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.01.2007 00:00:00", "activity_description": "Restore", "ctn": 7410234983, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410235833, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "11.10.2007 00:00:00", "activation_date": "01.09.2007 00:00:00", "activity_description": "Restore", "ctn": 7410280457, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.07.2015 00:00:00", "activation_date": "24.07.2015 00:00:00", "activity_description": "Change CTN", "ctn": 7410531447, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.08.2016 00:00:00", "activation_date": "24.08.2016 00:00:00", "activity_description": "Activation", "ctn": 7410572815, "ctn_status": "A" }, { "pp": "BASE1B", "last_status_date": "24.08.2016 00:00:00", "activation_date": "24.08.2016 00:00:00", "activity_description": "Activation", "ctn": 7410572851, "ctn_status": "A" } ] } } ], "ban_info": { "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ ԻՐԱՆԻ ԻՍԼԱՄԱԿԱՆ ՀԱՆՐԱՊԵՏՈ", "account_type": 45, "address": "Երեվան ԲՈՒԴԱՂՅԱՆ 1", "available_limit": 369724.20000000001, "ban_status": "O", "ban_balance": 33091.970000000001, "plan": "postpaid", "ban": 112743857, "contact_number": 7410234900 } } };

        const data = {
            innSelectedItem: resolve.data
        };

        if ( this.curator === 'curator' ) {
            data['banSelectedItem'] = resolve.data;
        }

        this.setState( data );

    }

    getDecryptedToken(){
        return new SimpleCrypto( config.simpleCryptoSecretKey ).decrypt( this.state.loginToken );
    }

    errorModal(){

        if ( !this.state.showErrorModal ) {
            return '';
        }

        return (
            <ErrorModal
                title={trans( this.props.b2bTrans, 'b2b.error.modal.title' )}
                description={trans( this.props.b2bTrans, 'b2b.error.modal.description' )}
                action_text={trans( this.props.b2bTrans, 'b2b.error.modal.action_text' )}
            />
        );

    }

    doSearch(){

        if ( this.state[this.state.activeTab + 'Val'] === '' ) {
            return;
        }

        if ( this.state.activeTab === 'inn' && this.state[this.state.activeTab + 'Val'].length === this.state[this.state.activeTab + 'MaxLength'] ) {

            const pathname = this.getInnPath();
            this.props.history.push( pathname );
            this.getInnData();
        } else if ( this.state.activeTab === 'ban' ) {

            if ( this.curator !== 'curator' ) {

                const pathname = this.getBanPath();
                this.props.history.push( pathname );

                this.getInfoByBan();
            }

        } else if ( this.state.activeTab === 'ctn' ) {

            if ( this.state.ctnVal !== '' ) {
                const pathname = this.getCtnPath();
                this.props.history.push( pathname );

                this.getInfoByCtn( this.state.ctnVal, true );

            }
        }

    }

    searchForm(){

        let currentButtonDisabled = false;

        if ( this.state.activeTab === 'inn' ) {
            currentButtonDisabled = this.state['innMaxLength'] !== this.state['innVal'].length;
        }

        return (
            <form action="#" method="post" className="form form--search" onSubmit={( event ) => {
                event.preventDefault();
                this.doSearch();

                if ( this.curator === 'curator' ) {
                    this.setState({
                        banFilter: true
                    });
                }

            }}>
                <div className="form__form-box pr">
                    <input
                        className="form__field fs14"
                        type="text"
                        placeholder={trans(this.props.b2bTrans, 'b2b.search.placeholder_' + this.state.activeTab)}
                        value={this.state[this.state.activeTab + 'Val']}
                        onChange={( event ) => {

                            let val = event.target.value.trim().replace(/[^\d]/g, '');

                            if ( this.state.hasOwnProperty(this.state.activeTab + 'MaxLength') ) {

                                const maxLength = this.state[this.state.activeTab + 'MaxLength'];
                                if ( val.length > maxLength ) {
                                    val = val.substr(0, maxLength );
                                }
                            }

                            const newState = {};
                            newState[this.state.activeTab + 'Val'] = val;

                            if ( this.curator === 'curator' && this.state.banFilter ) {
                                newState['banFilter'] = false;
                            }

                            this.setState( newState );
                        }}
                    />
                    <button
                        className="form__search-btn sprite"
                        type="submit"
                        disabled={this.state.buttonDisabled || currentButtonDisabled}
                    >&nbsp;</button>
                </div>
            </form>
        );

    }

    getInnPath(){

        let innActiveBan = this.state.innActiveBan;

        if ( innActiveBan === '' ) {
            innActiveBan = this.innActiveBan;
        }

        return config.urlPrefix +
               this.state.urlPrefix +
               '/inn' +
               ( this.state.innVal !== '' ? '/' + this.state.innVal : '' ) +
               ( this.state.innVal !== '' && innActiveBan !== '' ? '/ban/' + innActiveBan : '' ) +
               ( this.state.innActiveCtn !== '' ? '/ctn/' + this.state.innActiveCtn : '' );

    }

    getBanPath(){

        return config.urlPrefix +
               this.state.urlPrefix +
               '/ban' +
               ( this.state.banVal !== '' ? '/' + this.state.banVal : '' ) +
               ( this.state.banVal !== '' && this.state.banActiveCtn ? '/ctn/' + this.state.banActiveCtn : '' );

    }

    getCtnPath(){

        return config.urlPrefix +
               this.state.urlPrefix +
               '/ctn' +
               ( this.state.ctnVal !== '' ? '/' + this.state.ctnVal : '' );

    }

    tabView( escapeFirst = false ){

        const innItem = {
            title: trans(this.props.b2bTrans, 'b2b.search.tab_title_inn'),
            content: this.searchForm(),
            clickCallback: () => {
                const pathname = this.getInnPath();
                this.props.history.push( pathname );
                this.setState({
                    activeTab: 'inn',
                    pathname: this.filteredArray( pathname )
                });

                if ( this.state.innActiveCtnView && this.state.innActiveTabIndex === 1 && this.state.innActiveCtn !== '' ) {
                    this.getInfoByCtn( this.state.innActiveCtn, true );
                }
            }
        };

        const tabItems = [{
            title: trans(this.props.b2bTrans, 'b2b.search.tab_title_ban'),
            content: this.searchForm(),
            clickCallback: () => {
                const pathname = this.getBanPath();
                this.props.history.push( pathname );
                this.setState({
                    activeTab: 'ban',
                    banBoxCtnItems: '',
                    pathname: this.filteredArray( pathname )
                });

                if ( this.state.banActiveCtnView && this.state.banActiveTabIndex === 1 && this.state.banActiveCtn !== '' ) {
                    this.getInfoByCtn( this.state.banActiveCtn, true );
                }

            }
        },{
            title: trans(this.props.b2bTrans, 'b2b.search.tab_title_ctn'),
            content: this.searchForm(),
            clickCallback: () => {
                const pathname = this.getCtnPath();
                this.props.history.push( pathname );

                this.setState({
                    activeTab: 'ctn',
                    pathname: this.filteredArray( pathname ),
                    ctnBoxCtnItems: ''
                });

                if ( this.state.ctnVal !== '' ) {
                    this.getInfoByCtn( this.state.ctnVal, true );
                }
            }
        }];

        if ( !escapeFirst ) {

            tabItems.unshift( innItem );

        }

        return tabItems;

    }

    infiniteScroll( event, count ){

        if ( !this.componentIsMounted ) {
            return;
        }

        if (
            (event.target.scrollTop + event.target.offsetHeight > event.target.scrollHeight - 50) &&
            ( count > this.state[this.state.activeTab + 'ScrollShowItems'] )
        ) {
            const newState = {};

            newState[this.state.activeTab + 'ScrollShowItems'] = this.state[this.state.activeTab + 'ScrollShowItems'] + this.state[this.state.activeTab + 'ScrollLimit'];

            this.setState( newState );
        }

    }

    innList( list, count ){

        if ( ( this.state[this.state.activeTab + 'Val'] === '' && this.state[this.state.activeTab + 'Items'] !== '' ) ||
            ( this.state[this.state.activeTab + 'Val'] !== '' && this.state[this.state.activeTab + 'Items'] !== '' ) ) {

            const current = this.state[this.state.activeTab + 'Items'];

            if ( current.status === 'OK' && current.data.hasOwnProperty('info') && current.data.info.hasOwnProperty('bans') && current.data.count ) {

                count = current.data.count;

                list = current.data.info.bans.map(( item, index ) => {

                    if ( index + 1 > this.state.innScrollShowItems ) {
                        return '';
                    }

                    const path = config.urlPrefix + this.state.urlPrefix + '/' +
                                ( this.state[this.state.activeTab + 'Val'] !== '' ? this.state.activeTab + '/' + this.state[this.state.activeTab + 'Val'] + '/' : '' ) +
                                'ban/' + item.ban;

                    return (
                        <li className="list__item" key={index}>
                            <Link
                                className={`list__link clear-fix db pr sprite-a${this.state.innActiveBan === item.ban || this.innActiveBan === item.ban ? ' list__link--active' : ''}`}
                                to={path}
                                onClick={( event ) => {

                                    if ( this.state['innVal'].length !== this.state['innMaxLength'] ) {
                                        event.preventDefault();
                                    }

                                    if ( ( this.innActiveBan !== '' && this.innActiveBan !== item.ban ) || ( this.innActiveBan === '' && this.state.innActiveBan !== item.ban ) ) {

                                        this.setState({
                                            innActiveCtnView: false,
                                            innActiveBan: item.ban,
                                            pathname: this.filteredArray( path )
                                        });

                                        this.innActiveBan = '';

                                        this.getInfoByBanForView( this.state.innVal, item.ban );

                                    }

                                }}
                            >
                                <span className="list__title db monserrat-medium">{item.business_name}</span>
                                <span className="list__description db fs12">{trans(this.props.b2bTrans, 'b2b.ban.number')} {item.ban}</span>
                                {
                                    this.state.innActiveBan === item.ban || this.innActiveBan === item.ban ?
                                    this.balanceView()
                                    : ''
                                }
                            </Link>
                        </li>
                    );

                });

            } else if ( current.status === 'ERROR' || current.status === 'NOT_FOUND' ) {
                list = <li className="list__item">
                    <p className="error-message word-break">{current.code}</p>
                </li>;
            }

            list = <ul className="list list--b2b mb-none">{list}</ul>

        }

        return { list, count };

    }

    banList( list ){

        if ( ( this.state.banVal === '' && this.state.banSelectedItem !== '' ) ||
            ( this.state.banVal !== '' && this.state.banSelectedItem !== '' ) ) {

            const current = this.state.banSelectedItem;

            if ( current.status === 'OK' && current.data.hasOwnProperty('ban_info') ) {

                list = (
                    <li className="list__item">
                        <div className="list__link list__link--active clear-fix pr sprite-a">
                            <span className="list__title db monserrat-medium">{current['data']['ban_info']['business_name']}</span>
                            <span className="list__description db fs12">{trans(this.props.b2bTrans, 'b2b.ban.number')} {current['data']['ban_info']['ban']}</span>
                            {this.balanceView()}
                        </div>
                    </li>
                );

            } else if ( current.status === 'ERROR' || current.status === 'NOT_FOUND' ) {
                list = <li className="list__item">
                    <p className="error-message word-break">{current.code}</p>
                </li>;
            }

            list = <ul className="list list--b2b mb-none">{list}</ul>

        }

        return list;

    }

    curatorFilter( bans ){

        return bans.reduce(( arr, item ) => {
            if ( item.ban.toString().search( this.state.banVal ) > -1 ) {
                arr.push(item);
            }
            return arr;
        }, []);

    }

    banListCurator( list, count ){

        if ( this.state.banItems !== '' && this.state.banItems.status === 'OK' ) {

            let banList = this.state.banItems.data.info.bans;

            count = this.state.banItems.data.count;

            if ( this.state.banFilter ) {

                banList = this.curatorFilter( banList );
                count = banList.length;

            }

            list = banList.map(( item, index ) => {

                if ( index + 1 > this.state.banScrollShowItems ) {
                    return '';
                }

                const path = config.urlPrefix + this.state.urlPrefix + '/ban/' + item.ban;

                return (
                    <li className="list__item" key={index}>
                        <Link
                            className={`list__link clear-fix db pr sprite-a${this.state.banActiveBan === item.ban ? ' list__link--active' : ''}`}
                            to={path}
                            onClick={() => {

                                if ( this.state.banActiveBan !== item.ban ) {

                                    this.setState({
                                        banActiveCtnView: false,
                                        banActiveBan: item.ban,
                                        banVal: item.ban,
                                        pathname: this.filteredArray( path )
                                    });

                                    this.getInfoByBanForView( this.state.profileData.data.inn, item.ban );

                                }

                            }}
                        >
                            <span className="list__title db monserrat-medium">{item.business_name}</span>
                            <span className="list__description db fs12">{trans(this.props.b2bTrans, 'b2b.ban.number')} {item.ban}</span>
                            { this.state.banActiveBan === item.ban ? this.balanceView() : '' }
                        </Link>
                    </li>
                );

            });

            if ( this.state.banFilter && count === 0 ) {
                list = <li className="list__item">
                           <p className="empty-message fs14">{trans( this.props.b2bTrans, 'b2b.empty.message' )}</p>
                       </li>;
            }

        } else if ( this.state.banItems !== '' && ( this.state.banItems.status === 'ERROR' || this.state.banItems.status === 'NOT_FOUND' ) ) {
            list = <li className="list__item">
                       <p className="error-message word-break">{this.state.banItems.code}</p>
                   </li>;
        }

        list = <ul className="list list--b2b mb-none">{list}</ul>;

        return {list, count};

    }

    ctnList( list ){

        if ( ( this.state[this.state.activeTab + 'Val'] === '' && this.state[this.state.activeTab + 'Items'] !== '' ) ||
            ( this.state[this.state.activeTab + 'Val'] !== '' && this.state[this.state.activeTab + 'Items'] !== '' ) ) {

            const current = this.state[this.state.activeTab + 'BoxCtnItems'];

            if ( current.status === 'OK' && current.data.hasOwnProperty('info') ) {

                list = (
                    <li className="list__item">
                        <div className="list__link list__link--active clear-fix pr sprite-a">
                            <span className="list__title db monserrat-medium">{current['data']['info']['business_name']}</span>
                            <span className="list__description db fs12">{trans(this.props.b2bTrans, 'b2b.ban.number')} {current['data']['info']['ban']}</span>
                            {this.balanceView()}
                        </div>
                    </li>
                );

            } else if ( current.status === 'INVALID_DATA' ) {
                list = (
                    <li className="list__item">
                        <p className="error-message word-break">{JSON.stringify( current.errors )}</p>
                    </li>
                );
            } else if ( current.status === 'ERROR' || current.status === 'NOT_FOUND' ) {
                list = (
                    <li className="list__item">
                        <p className="error-message word-break">{current.code}</p>
                    </li>
                );
            }

            list = <ul className="list list--b2b mb-none">{list}</ul>

        }

        return list;

    }

    getBanExportLink(){

        let url = '';

        if ( this.curator === 'curator' ) {

            if ( this.state.profileData !== '' && this.state.profileData.status === 'OK' ) {
                url = '/api/' +
                      localStorageGetItem('defaultLngPrefix') + '/' +
                      this.state.urlPrefix + this.curator +
                      '/getInfoByInn?inn=' + this.state.profileData.data.inn + '&' +
                      'jwt=' + this.getDecryptedToken() + '&action=export';
            }

            if ( url === '' ) {
                return '';
            }

        } else {

            if ( this.state['innVal'] === '' || this.state['innVal'].length !== this.state['innMaxLength'] || this.state['innItems'] === '' ) {
                return '';
            }

            url = '/api/' +
                  localStorageGetItem('defaultLngPrefix') + '/' +
                  this.state.urlPrefix + '/getInfoByInn?' +
                  'inn='+this.state['innVal']+'&' +
                  'jwt=' + this.getDecryptedToken() + '&action=export';

        }

        return (
            <a
                href={url}
                className="main-wrapper__bottom-export fs14 ver-top-box sprite-a pr"
                target="_blank"
                rel="noopener noreferrer"
            >{trans(this.props.b2bTrans, 'b2b.ban_list.export_title')}</a>
        );

    }

    activeTabIndex(){

        let pathname = this.state.pathname[1],
            activeTabIndex = 0;

        if ( pathname === 'ban' ) {
            activeTabIndex = this.curator === 'curator' ? 0 : 1;
        } else if ( pathname === 'ctn' ) {
            activeTabIndex = this.curator === 'curator' ? 1 : 2;
        }

        return activeTabIndex;

    }

    leftSidebar(){

        let list = '',
            count = 0;

        if ( this.state.activeTab === 'inn' ) {

            const innList = this.innList( list, count );

            list = innList['list'];
            count = innList['count'];

        } else if ( this.state.activeTab === 'ban' ) {

            if ( this.curator === 'curator' ) {

                const banList = this.banListCurator( list, count );

                list = banList['list'];
                count = banList['count'];

            } else {
                this.banList()
            }

        } else if ( this.state.activeTab === 'ctn' ) {
            list = this.ctnList();
        } if ( this.state.buttonDisabled ) {
            list = <Loading withBox={true} />;
        }

        return (
            <aside className="main-wrapper__left">
                <div className="form__info-box pa tr">
                    <div className="form__info sprite">&nbsp;</div>
                    <div className="form__info-txt fs11 pa" dangerouslySetInnerHTML={{__html: trans( this.props.b2bTrans, 'b2b.left_sidebar.info_text' + ( this.curator === 'curator' ? '_curator' : '' ) )}} />
                </div>
                <div className={`main-wrapper__left-top pr${this.curator === 'curator' ? ' main-wrapper__left-top--curator' : ''}`}>
                    <Tab
                        items={this.tabView( this.curator === 'curator' )}
                        index={this.activeTabIndex()}
                        changeTab={true}
                    />
                </div>
                <div className="main-wrapper__left-inner scroller-block" onScroll={( event ) => this.infiniteScroll( event, count )}>
                    <div className="main-wrapper__left-container">{list}</div>
                </div>
                <div className="main-wrapper__bottom">{this.getBanExportLink()}</div>
                <button
                    className="main-wrapper__left-toggle pa sprite-b center-center-before"
                    type="button"
                    onClick={() => this.setState({ leftMenuToggle: !this.state.leftMenuToggle })}
                >&nbsp;</button>
            </aside>
        );

    }

    reSendData(){

        this.setState({ logoutBtnDisabled: true });

        ApiManager.getRequest({}, '/csrf-token').then(( resolve ) => {
            this.props.setTokenAction( resolve.data );
            this.setState({ _token: resolve.data.data });
            this.logout();
        }, () => {
            this.setState({ showErrorModal: true });
        });

    }

    logout(){

        this.setState({ logoutBtnDisabled: true });

        ApiManager.postRequest({
            _token: this.props.csrf_token.data,
            jwt: this.getDecryptedToken()
        }, '/b2b' + this.curator + '/logout').then(( resolve ) => {

            // @test
            // resolve.data = {status: "OK", message: "Աղբյուրը չի գտնվել"};

            if ( resolve.data.status === 'OK' ) {
                this.props.setCurrentTabAction( 1 );
                this.props.cookies.remove('loginTokenB2b', { path: config.urlPrefix });
                this.props.history.push( config.urlPrefix );

                if ( this.curator !== '' ) {
                    this.props.cookies.remove('loginByCurator', { path: config.urlPrefix });
                }

            } else if ( resolve.data.status === 'ERROR' || resolve.data.status === 'NOT_FOUND' || resolve.data.status === 'APP_ERROR' ) {
                this.errorCallBack();
            } else if ( resolve.data.status === 'CSRF_TOKEN_MISMATCH' ) {
                this.reSendData();
            }

        }, this.errorCallBack);

    }

    languageChange(){

        this.setState({
            isLanguageChanged: true
        });

    }

    logoBox(){

        return (
            <div className="main-wrapper__logo-box pr clear-fix">
                <Link
                    className="main-wrapper__logo-link db fl"
                    to={config.urlPrefix + this.state.urlPrefix}
                    onClick={() => this.resetValues()}
                >
                    <img className="main-wrapper__account-logo ver-middle-box" src={config.imgURLPrefix + 'img/account-logo.png'} alt={trans( this.props.b2bTrans, 'b2b.logo.title' )} />
                    <span className="main-wrapper__right-title ver-middle-box fs18">{trans( this.props.b2bTrans, 'b2b.logo.title' )}</span>
                </Link>

                <B2bUserInfo
                    b2bTrans={this.props.b2bTrans}
                    csrf_token={this.props.csrf_token}
                    logout={this.logout}
                    logoutBtnDisabled={this.state.logoutBtnDisabled}
                    urlPrefix={this.state.urlPrefix}
                    updatePath={this.updatePath}
                    profileData={this.state.profileData}
                    updateParentState={this.updateParentState}
                    curator={this.curator}
                />

                <button
                    className="main-wrapper__report-link fb fr sprite-b trans-background pr tl"
                    type="button"
                    onClick={() => {
                        this.props.history.push( config.urlPrefix + this.state.urlPrefix + '/financialReports' );
                        this.updatePath();
                    }}
                >{trans( this.props.b2bTrans, 'b2b.financial_reports.title' )}</button>

                <button
                    className="main-wrapper__notification-btn fr sprite-b center-center-before pr"
                    type="button"
                    onClick={() => {
                        this.props.history.push( config.urlPrefix + this.state.urlPrefix + '/applications' );
                        this.updatePath();
                    }}
                >
                    <span className="main-wrapper__notification-count db fs12 pa tc">{this.state.notificationCount}</span>
                </button>

                <B2bLanguageList
                    updateParentState={this.updateParentState}
                    setTranslationsAction={this.props.setTranslationsAction}
                    b2bTrans={this.props.b2bTrans}
                    languageChange={this.languageChange}
                />

            </div>
        );

    }

    bottomBox(){

        return (
            <div className="main-wrapper__bottom-group">

                <div className="main-wrapper__bottom-block clear-fix">

                    <p className="main-wrapper__bottom-txt fl fs14">{trans(this.props.b2bTrans, 'b2b.bottom.title')} <Link className="main-wrapper__bottom-link" to={config.urlPrefix + this.state.urlPrefix} onClick={() => this.resetValues()}>{trans(this.props.b2bTrans, 'b2b.bottom.link')}</Link></p>
                    <p className="main-wrapper__bottom-txt fr fs14" dangerouslySetInnerHTML={{__html: trans(this.props.b2bTrans, 'b2b.copyright.text').replace(/%s/, new Date().getFullYear())}} />

                </div>
            </div>
        );

    }

    rightSidebar(){

        let rightContent = <EmptyBox title={trans( this.props.b2bTrans, 'b2b.empty.title' )} />;

        if ( this.state.pathname[1] === 'ctn' && ( this.state.activeTab === 'ctn' && this.state[this.state.activeTab + 'BoxCtnItems'] !== '' && this.state.ctnActiveCtnView ) ) {

            rightContent = (
                <div className="main-wrapper__right-inner scroller-block pr">
                    <div className="main-wrapper__right-content">
                        <B2bCtnView
                            innBoxCtnItems={this.state.innBoxCtnItems}
                            innSelectedItem={this.state.innSelectedItem}
                            innActiveCtnView={this.state.innActiveCtnView}
                            innActiveTabIndex={this.state.innActiveTabIndex}

                            banBoxCtnItems={this.state.banBoxCtnItems}
                            banActiveCtnView={this.state.banActiveCtnView}
                            banSelectedItem={this.state.banSelectedItem}
                            banActiveTabIndex={this.state.banActiveTabIndex}
                            banVal={this.state.banVal}

                            ctnActiveCtnView={this.state.ctnActiveCtnView}
                            ctnBoxCtnItems={this.state.ctnBoxCtnItems}
                            ctnActiveTabIndex={this.state.ctnActiveTabIndex}

                            activeTab={this.state.activeTab}
                            urlPrefix={this.state.urlPrefix}
                            profileData={this.state.profileData}
                            b2bTrans={this.props.b2bTrans}
                            history={this.props.history}
                            getDecryptedToken={this.getDecryptedToken}
                            updateParentState={this.updateParentState}
                            csrf_token={this.props.csrf_token}
                            curator={this.curator}
                        />
                    </div>
                </div>
            );

        } else if ( ( this.state.pathname[1] === 'inn' && this.state.activeTab === 'inn' && this.state.innSelectedItem !== '' ) || ( this.state.pathname[1] === 'ban' && this.state.activeTab === 'ban' && this.state.banSelectedItem !== '' ) ) {

            rightContent = (
                <B2bBanInfo
                    innActiveCtnView={this.state.innActiveCtnView}
                    innItems={this.state.innItems}
                    innSelectedItem={this.state.innSelectedItem}
                    innVal={this.state.innVal}
                    innMaxLength={this.state.innMaxLength}
                    innActiveBan={this.state.innActiveBan || this.innActiveBan}
                    innActiveTabIndex={this.state.innActiveTabIndex}
                    innBoxCtnItems={this.state.innBoxCtnItems}

                    banBoxCtnItems={this.state.banBoxCtnItems}
                    banSelectedItem={this.state.banSelectedItem}
                    banActiveTabIndex={this.state.banActiveTabIndex}
                    banActiveCtnView={this.state.banActiveCtnView}
                    banVal={this.state.banVal}

                    ctnBoxCtnItems={this.state.ctnBoxCtnItems}
                    ctnActiveCtnView={this.state.ctnActiveCtnView}
                    ctnActiveTabIndex={this.state.ctnActiveTabIndex}

                    profileData={this.state.profileData}
                    getDecryptedToken={this.getDecryptedToken}
                    updateParentState={this.updateParentState}
                    getInfoByCtn={this.getInfoByCtn}
                    urlPrefix={this.state.urlPrefix}
                    activeTab={this.state.activeTab}
                    history={this.props.history}
                    csrf_token={this.props.csrf_token}
                    b2bTrans={this.props.b2bTrans}
                    curator={this.curator}
                    updatePath={this.updatePath}
                />
            );

        } else if ( this.state.pathname[1] === 'curatorList' ) {

            rightContent = (
                <B2bCuratorList
                    getDecryptedToken={this.getDecryptedToken}
                    updateParentState={this.updateParentState}
                    getInnData={this.getInnData}
                    updatePath={this.updatePath}
                    urlPrefix={this.state.urlPrefix}
                    profileData={this.state.profileData}
                    b2bTrans={this.props.b2bTrans}
                    csrf_token={this.props.csrf_token}
                    history={this.props.history}
                    curator={this.curator}
                />
            );

        } else if ( this.state.pathname[1] === 'myAccount' ) {

            rightContent = (
                <B2bMyAccount
                    profileData={this.state.profileData}
                    b2bTrans={this.props.b2bTrans}
                    curator={this.curator}
                    getDecryptedToken={this.getDecryptedToken}
                    getProfile={this.getProfile}
                    // history={this.props.history}
                    // urlPrefix={this.state.urlPrefix}
                    errorCallBack={this.errorCallBack}
                    csrf_token={this.props.csrf_token}
                />
            );

        } else if ( this.state.pathname[1] === 'createCurator' ) {

            if ( this.state.profileData === '' ) {
                rightContent = <Loading />;
            } else {

                rightContent = (
                    <B2bCreateCurator
                        errorCallBack={this.errorCallBack}
                        getDecryptedToken={this.getDecryptedToken}
                        updatePath={this.updatePath}
                        urlPrefix={this.state.urlPrefix}
                        profileData={this.state.profileData}
                        b2bTrans={this.props.b2bTrans}
                        history={this.props.history}
                        csrf_token={this.props.csrf_token}
                        curator={this.curator}
                    />
                );

            }

        } else if ( this.state.pathname[1] === 'editCurator' ) {

            rightContent = (
                <B2bCreateCurator
                    errorCallBack={this.errorCallBack}
                    getDecryptedToken={this.getDecryptedToken}
                    updatePath={this.updatePath}
                    urlPrefix={this.state.urlPrefix}
                    pathname={this.state.pathname}
                    b2bTrans={this.props.b2bTrans}
                    history={this.props.history}
                    csrf_token={this.props.csrf_token}
                    curator={this.curator}
                    editCurator={true}
                />
            );

        } else if ( this.state.pathname[1] === 'createApplication' && this.state.applicationData.length ) {

            rightContent = (
                <B2bCreateApplication
                    errorCallBack={this.errorCallBack}
                    getDecryptedToken={this.getDecryptedToken}
                    updatePath={this.updatePath}
                    urlPrefix={this.state.urlPrefix}
                    pathname={this.state.pathname}
                    banActiveBan={this.state.banActiveBan}
                    b2bTrans={this.props.b2bTrans}
                    history={this.props.history}
                    csrf_token={this.props.csrf_token}
                    curator={this.curator}
                    applicationData={this.state.applicationData}
                    activeBan={this.state.banActiveBan}
                    updateParentState={this.updateParentState}
                    banSelectedTp={this.state.banSelectedTp}
                    isLanguageChanged={this.state.isLanguageChanged}
                />
            );

        } else if ( this.state.pathname[1] === 'applications' ) {

            rightContent = (
                <B2bApplications
                    errorCallBack={this.errorCallBack}
                    getDecryptedToken={this.getDecryptedToken}
                    updatePath={this.updatePath}
                    urlPrefix={this.state.urlPrefix}
                    pathname={this.state.pathname}
                    b2bTrans={this.props.b2bTrans}
                    history={this.props.history}
                    csrf_token={this.props.csrf_token}
                    curator={this.curator}
                    updateParentState={this.updateParentState}
                    profileData={this.state.profileData}
                />
            );

        } else if ( this.state.pathname[1] === 'applicationEdit' ) {

            rightContent = (
                <B2bEditApplication
                    errorCallBack={this.errorCallBack}
                    getDecryptedToken={this.getDecryptedToken}
                    updatePath={this.updatePath}
                    urlPrefix={this.state.urlPrefix}
                    pathname={this.state.pathname}
                    b2bTrans={this.props.b2bTrans}
                    history={this.props.history}
                    csrf_token={this.props.csrf_token}
                    curator={this.curator}
                />
            );

        } else if ( this.state.pathname[1] === 'financialReports' ) {

            rightContent = (
                <B2bFinancialReports
                    errorCallBack={this.errorCallBack}
                    getDecryptedToken={this.getDecryptedToken}
                    b2bTrans={this.props.b2bTrans}
                    curator={this.curator}
                    profileData={this.state.profileData}
                />
            );

        }

        return (
            <div className="main-wrapper__right pa">{rightContent}</div>
        );

    }

    render(){

        this.logoutTimer();

        return(

            <div
                className={`main-wrapper main-wrapper--account main-wrapper--b2b ${localStorageGetItem( 'defaultLngPrefix')}${this.state.leftMenuToggle ? ' main-wrapper--b2b-toggle-menu' : ''}`}
            >
                {this.leftSidebar()}
                {this.logoBox()}
                {this.rightSidebar()}
                {this.bottomBox()}
                {this.errorModal()}
            </div>

        );

    }

}

export default withRouter(
    withCookies(
        B2bProfileView
    )
);
